import React, { useEffect } from "react";
import styles from "./PageNotFound.module.css";
import { useDispatch } from "react-redux";
import { sidebarActions } from "@_actions/sidebar.actions";

const PageNotFound = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(sidebarActions.updateStatus(""));
  }, [dispatch]);
  return (
    <div className={styles.page_not_fount_container}>
      <div className={styles.page_not_fount_text}>Page not found.</div>
    </div>
  );
};

export default PageNotFound;
